export default function noSentenceSupportingAssoc() {
  return 'No supporting publication provided by the source database';
}
